module.exports = __webpack_public_path__ + "img/imagen2.2a690864.png";